var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-auto order-2 order-md-3"},[_c('div',{staticClass:"v-navbar-menu d-flex align-items-end"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }